import * as Cesium from '@cesiumgs/cesium-analytics'
import * as turf from '@turf/turf'
import Draw from '@/components/Cesium/Draw/Draw'
import { DrawEventType } from '@/components/Cesium/Draw/DrawEventType'
import { DrawType } from '@/components/Cesium/Draw/DrawType'

import { getPositionDistance, word2Lnglat } from '@/components/Cesium/CartesianOrWkt'

class CustomMeasureNew {
  cesiumview: any
  drawTool: any
  dataSourceDraw: any
  coordinatesData: any = [] // save draw coordinates data
  TypeArr: any = []
  pickHandler: any //
  pickBillboard: any
  _handlersHeight: any
  _isStartMeasure = false
  constructor(vivewr: Cesium.Viewer, closedCallback: () => void) {
    this.cesiumview = vivewr
    this.dataSourceDraw = new Cesium.CustomDataSource('drawSnappingData')
    this.cesiumview && this.cesiumview.dataSources.add(this.dataSourceDraw)
    this.drawTool = new Draw(vivewr)
    this.closeSimpleEntity(closedCallback)
  }

  spatialDistance() {
    const action = this.drawTool.create(DrawType.Polyline, {
      useDefaultEntity: true,
    })
    action.on(DrawEventType.VertexAdd, () => {})
    action.on(DrawEventType.Complete, (evt: any) => {
      if (evt.length > 1) {
        this.coordinatesData.push(evt)
        this.TypeArr.push(2)
        this.againDrawGraphical()
      }
      action.destroy()
    })
  }

  planeDistance() {
    const action = this.drawTool.create(DrawType.Polyline, {
      useDefaultEntity: true,
    })
    action.on(DrawEventType.VertexAdd, () => {})
    action.on(DrawEventType.Complete, (evt: any) => {
      if (evt.length > 1) {
        this.coordinatesData.push(evt)
        this.TypeArr.push(1)
        this.againDrawGraphical()
      }
      action.destroy()
    })
  }

  areaMeasure() {
    const action = this.drawTool.create(DrawType.Polygon, {
      useDefaultEntity: true,
    })
    action.on(DrawEventType.VertexAdd, () => {})
    action.on(DrawEventType.Complete, (evt: any) => {
      if (evt.length > 1) {
        this.coordinatesData.push(evt)
        this.TypeArr.push(3)
        this.againDrawGraphical()
      }
      action.destroy()
    })
  }

  drawTrianglesMeasureGraphics() {
    if (this.cesiumview) {
      let currLineEntity: any = null
      let _positions: any = []
      let _tempPoints: any = []
      let _tempPoints2: any = []

      this._handlersHeight = new Cesium.ScreenSpaceEventHandler(
        this.cesiumview.scene.canvas,
      )
      // left
      this._handlersHeight && this._handlersHeight.setInputAction((movement: any) => {
        const position = this.getCatesian3FromPX(movement.position)
        if (!position && !position.z)
          return false
        if (this._isStartMeasure) {
          return false
        }
        if (_positions.length === 0) {
          _positions.push(position.clone())
          _positions.push(position.clone())
          _tempPoints.push(position.clone())
          _tempPoints.push(position.clone())
          // mouse
          this._isStartMeasure = true
          // line
          currLineEntity = new Cesium.Entity({
            polyline: {
              positions: new Cesium.CallbackProperty(() => {
                return _positions
              }, false),
              width: 3,
              material: Cesium.Color.YELLOW.withAlpha(0.5),
            },
            position: new Cesium.CallbackProperty(() => {
              return _positions[0]
            }, false) as any,
            point: {
              pixelSize: 5,
              outlineColor: Cesium.Color.YELLOW,
              outlineWidth: 5,
            },
            label: {
              text: new Cesium.CallbackProperty(() => {
                return (
                  `높이:${
                  Math.abs(
                    Number(
                      Number(
                        this._getHeading(_tempPoints[0], _tempPoints[1]),
                      ).toFixed(2),
                    ),
                  )
                  } m\n`
                  + `사선 거리 :${
                  Number(
                    this.getPositionDistanceHeight(
                      this.transformCartesianArrayToWGS84Array(_positions),
                    ),
                  ).toFixed(2)
                  } m\n`
                  + `수평 거리:${
                  Number(
                    this.getPositionDistanceHeight(
                      this.transformCartesianArrayToWGS84Array(_tempPoints2),
                    ),
                  ).toFixed(2)
                  }m`
                )
              }, false),

              show: true,
              showBackground: true,
              font: '14px monospace',
              horizontalOrigin: Cesium.HorizontalOrigin.LEFT,
              verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
              pixelOffset: new Cesium.Cartesian2(50, -100), // left top
            },
            billboard: {
              image: './measure/close.png',
              show: true, // default
              pixelOffset: new Cesium.Cartesian2(35, -95), // default: (0, 0)
              eyeOffset: new Cesium.Cartesian3(0.0, 0.0, 0.0), // default
              horizontalOrigin: Cesium.HorizontalOrigin.CENTER, // default
              verticalOrigin: Cesium.VerticalOrigin.BOTTOM, // default: CENTER
              alignedAxis: Cesium.Cartesian3.ZERO, // default
              width: 30, // default: undefined
              height: 30, // default: undefined
            },
          })

          this?.dataSourceDraw?.entities.add(currLineEntity)
          this._handlersHeight && this._handlersHeight.setInputAction((movement: any) => {
            const position = this.getCatesian3FromPX(movement.endPosition)
            if (position && _positions.length > 0) {
              // line
              _positions.pop()
              _positions.push(position.clone())
              const horizontalPosition
                = this._computesHorizontalLine(_positions)
              // height
              _tempPoints.pop()
              _tempPoints.push(horizontalPosition.clone())
              // shuiping line
              _tempPoints2.pop()
              _tempPoints2.pop()
              _tempPoints2.push(position.clone())
              _tempPoints2.push(horizontalPosition.clone())
            }
          }, Cesium.ScreenSpaceEventType.MOUSE_MOVE)
        }
      }, Cesium.ScreenSpaceEventType.LEFT_CLICK)

      // right
      this._handlersHeight && this._handlersHeight.setInputAction((movement: any) => {
        if (!this._isStartMeasure) {
          return false
        }
        this._handlersHeight = this._handlersHeight && this._handlersHeight.destroy()
        this._handlersHeight = null

        if (_positions.length === 2) {
          this.coordinatesData.push(_positions)
          this?.dataSourceDraw?.entities.remove(currLineEntity)
          this.TypeArr.push(4)
          this.againDrawGraphical()
        }

        _positions = []
        _tempPoints = []
        _tempPoints2 = []
        this._isStartMeasure = false
      }, Cesium.ScreenSpaceEventType.RIGHT_CLICK)
      // create entity
    }
  }

  async againDrawGraphical() {
    this?.dataSourceDraw?.entities.removeAll()
    for (let index1 = 0; index1 < this.coordinatesData.length; index1++) {
      // this.coordinatesData.forEach((item,index1)=>{
      if (this.TypeArr[index1] === 1) {
        const entityLine = new Cesium.Entity({
          name: `measure1_${index1}`,
          polyline: {
            clampToGround: false,
            positions: new Cesium.CallbackProperty(() => {
              return this.coordinatesData[index1]
            }, false),
            width: 5,
            material: Cesium.Color.fromCssColorString('#FFD040').withAlpha(0.8),
          },
        })
        this?.dataSourceDraw?.entities.add(entityLine)
        const lnglatArr = word2Lnglat(this.cesiumview, this.coordinatesData[index1])
        const positionArr: any = []
        this.coordinatesData[index1].forEach((item: any, index2: number) => {
          positionArr.push(lnglatArr[index2])

          if (index2 !== 0) {
            const line = turf.lineString(positionArr)
            const lengthResult = turf.length(line, { units: 'kilometers' })
            let entityLabel = null
            if (index2 === this.coordinatesData[index1].length - 1) {
              entityLabel = new Cesium.Entity({
                position: new Cesium.CallbackProperty(() => {
                  return this.coordinatesData[index1][index2]
                }, false) as any,
                id: `labelandclose1_${index1}_${index2}`,
                name: `measure1_${index1}`,
                label: {
                  text: `${(lengthResult * 1000).toFixed(2)}m`,
                  font: '46px monospace',
                  scale: 0.5,
                  style: Cesium.LabelStyle.FILL,
                  fillColor: Cesium.Color.YELLOW,
                  pixelOffset: new Cesium.Cartesian2(0, -50),
                  showBackground: false,
                  backgroundColor: new Cesium.Color(0.5, 0.6, 1, 1.0),
                  disableDepthTestDistance: Number.POSITIVE_INFINITY,
                },
                billboard: {
                  image: './measure/close.png',
                  show: true, // default
                  pixelOffset: new Cesium.Cartesian2(-70, -35), // default: (0, 0)
                  eyeOffset: new Cesium.Cartesian3(0.0, 0.0, 0.0), // default
                  horizontalOrigin: Cesium.HorizontalOrigin.CENTER, // default
                  verticalOrigin: Cesium.VerticalOrigin.BOTTOM, // default: CENTER
                  alignedAxis: Cesium.Cartesian3.ZERO, // default
                  heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
                  width: 30, // default: undefined
                  height: 30, // default: undefined
                },
              })
            }
            else {
              entityLabel = new Cesium.Entity({
                position: new Cesium.CallbackProperty(() => {
                  return this.coordinatesData[index1][index2]
                }, false) as any,
                id: `label1_${index1}_${index2}`,
                name: `measure1_${index1}`,
                label: {
                  text: `${(lengthResult * 1000).toFixed(2)}m`,
                  font: '46px monospace',
                  scale: 0.5,
                  style: Cesium.LabelStyle.FILL,
                  fillColor: Cesium.Color.YELLOW,
                  pixelOffset: new Cesium.Cartesian2(-8, -35),
                  showBackground: false,
                  backgroundColor: new Cesium.Color(0.5, 0.6, 1, 1.0),
                  disableDepthTestDistance: Number.POSITIVE_INFINITY,
                },
              })
            }
            this?.dataSourceDraw?.entities.add(entityLabel)
          }
          else {
            const entityLabel = new Cesium.Entity({
              position: new Cesium.CallbackProperty(() => {
                return this.coordinatesData[index1][index2]
              }, false) as any,
              id: `label1_${index1}_${index2}`,
              name: `measure1_${index1}`,
              label: {
                text: '',
                font: '46px monospace',
                scale: 0.5,
                style: Cesium.LabelStyle.FILL,
                fillColor: Cesium.Color.YELLOW,
                pixelOffset: new Cesium.Cartesian2(-8, -35),
                showBackground: false,
                backgroundColor: new Cesium.Color(0.5, 0.6, 1, 1.0),
                disableDepthTestDistance: Number.POSITIVE_INFINITY,
              },
            })
            this?.dataSourceDraw?.entities.add(entityLabel)
          }
        })
      }
      else if (this.TypeArr[index1] === 2) {
        const entityLine = new Cesium.Entity({
          name: `measure2_${index1}`,
          polyline: {
            clampToGround: true,
            positions: new Cesium.CallbackProperty(() => {
              return this.coordinatesData[index1]
            }, false),
            width: 5,
            material: Cesium.Color.fromCssColorString('#FFD040').withAlpha(0.8),
          },
        })
        this?.dataSourceDraw?.entities.add(entityLine)
        const lnglatArr = word2Lnglat(this.cesiumview, this.coordinatesData[index1])

        const positionArr = []
        for (let index2 = 0; index2 < this.coordinatesData[index1].length; index2++) {
          // this.coordinatesData[index1].forEach( async(item,index2)=>{
          positionArr.push(this.coordinatesData[index1][index2])
          if (index2 !== 0) {
            const res = Number(await getPositionDistance(positionArr, this.cesiumview))
            let entityLabel = null
            if (index2 === this.coordinatesData[index1].length - 1) {
              entityLabel = new Cesium.Entity({
                position: new Cesium.CallbackProperty(() => {
                  return this.coordinatesData[index1][index2]
                }, false) as any,
                id: `labelandclose2_${index1}_${index2}`,
                name: `measure2_${index1}`,
                label: {
                  text: `${Number(res).toFixed(2)}m`,
                  font: '46px monospace',
                  scale: 0.5,
                  style: Cesium.LabelStyle.FILL,
                  fillColor: Cesium.Color.YELLOW,
                  pixelOffset: new Cesium.Cartesian2(0, -50),
                  showBackground: false,
                  backgroundColor: new Cesium.Color(0.5, 0.6, 1, 1.0),
                  disableDepthTestDistance: Number.POSITIVE_INFINITY,
                },
                billboard: {
                  image: './measure/close.png',
                  show: true, // default
                  pixelOffset: new Cesium.Cartesian2(-70, -35), // default: (0, 0)
                  eyeOffset: new Cesium.Cartesian3(0.0, 0.0, 0.0), // default
                  horizontalOrigin: Cesium.HorizontalOrigin.CENTER, // default
                  verticalOrigin: Cesium.VerticalOrigin.BOTTOM, // default: CENTER
                  alignedAxis: Cesium.Cartesian3.ZERO, // default
                  width: 30, // default: undefined
                  height: 30, // default: undefined
                },
              })
            }
            else {
              entityLabel = new Cesium.Entity({
                position: new Cesium.CallbackProperty(() => {
                  return this.coordinatesData[index1][index2]
                }, false) as any,
                id: `label2_${index1}_${index2}`,
                name: `measure2_${index1}`,
                label: {
                  text: `${Number(res).toFixed(2)}m`,
                  font: '46px monospace',
                  scale: 0.5,
                  style: Cesium.LabelStyle.FILL,
                  fillColor: Cesium.Color.YELLOW,
                  pixelOffset: new Cesium.Cartesian2(-8, -35),
                  showBackground: false,
                  backgroundColor: new Cesium.Color(0.5, 0.6, 1, 1.0),
                  disableDepthTestDistance: Number.POSITIVE_INFINITY,
                },
              })
            }
            this?.dataSourceDraw?.entities.add(entityLabel)
          }
          else {
            const entityLabel = new Cesium.Entity({
              position: new Cesium.CallbackProperty(() => {
                return this.coordinatesData[index1][index2]
              }, false) as any,
              id: `label2_${index1}_${index2}`,
              name: `measure2_${index1}`,
              label: {
                text: '',
                font: '46px monospace',
                scale: 0.5,
                style: Cesium.LabelStyle.FILL,
                fillColor: Cesium.Color.YELLOW,
                pixelOffset: new Cesium.Cartesian2(-8, -35),
                showBackground: false,
                backgroundColor: new Cesium.Color(0.5, 0.6, 1, 1.0),
                disableDepthTestDistance: Number.POSITIVE_INFINITY,
              },
            })
            this?.dataSourceDraw?.entities.add(entityLabel)
          }
        }
        // })
      }
      else if (this.TypeArr[index1] === 3) {
        const entityLine = new Cesium.Entity({
          name: `measure3_${index1}`,
          polygon: {
            hierarchy: new Cesium.CallbackProperty(() => {
              return new Cesium.PolygonHierarchy(this.coordinatesData[index1])
            }, false) as any,
            material: Cesium.Color.YELLOW.withAlpha(0.3),
            heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
            outline: true,
            outlineColor: Cesium.Color.YELLOW,
            outlineWidth: 5,
          },
        })
        this?.dataSourceDraw?.entities.add(entityLine)
        const newcoordinatesData = [...this.coordinatesData[index1]]
        newcoordinatesData.push(newcoordinatesData[0])
        const lnglatArr = word2Lnglat(this.cesiumview, newcoordinatesData)
        const polygon = turf.polygon([lnglatArr])

        const area = turf.area(polygon)
        const entityLabel = new Cesium.Entity({
          position: new Cesium.CallbackProperty(() => {
            return this.coordinatesData[index1][0]
          }, false) as any,
          id: `labelandclose3_${index1}_${0}`,
          name: `measure3_${index1}`,
          label: {
            text: `${area.toFixed(2)}㎡`,
            font: '46px monospace',
            scale: 0.5,
            style: Cesium.LabelStyle.FILL,
            fillColor: Cesium.Color.YELLOW,
            // pixelOffset: new Cesium.Cartesian2(0, -60),
            pixelOffset: new Cesium.Cartesian2(0, -60),
            showBackground: false,
            backgroundColor: new Cesium.Color(0.5, 0.6, 1, 1.0),
            heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
            disableDepthTestDistance: Number.POSITIVE_INFINITY,
          },
          billboard: {
            image: './measure/close.png',
            show: true, // default
            // pixelOffset: new Cesium.Cartesian2(-70, -45), // default: (0, 0)
            pixelOffset: new Cesium.Cartesian2(-70, 0), // default: (0, 0)
            eyeOffset: new Cesium.Cartesian3(0.0, 0.0, 0.0), // default
            horizontalOrigin: Cesium.HorizontalOrigin.CENTER, // default
            verticalOrigin: Cesium.VerticalOrigin.BOTTOM, // default: CENTER
            alignedAxis: Cesium.Cartesian3.ZERO, // default
            heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
            width: 30, // default: undefined
            height: 30, // default: undefined
          },
        })

        this?.dataSourceDraw?.entities.add(entityLabel)
      }
      else if (this.TypeArr[index1] === 4) {
        const newcoordinatesData = [...this.coordinatesData[index1]]
        newcoordinatesData.push(this._computesHorizontalLine(this.coordinatesData[index1]))
        newcoordinatesData.push(this.coordinatesData[index1][0])
        const _trianglesEntity = new Cesium.Entity({
          id: `labelandclose4_${index1}_${0}`,
          name: `measure4_${index1}`,
          polyline: {
            positions: newcoordinatesData,
            width: 3,
            material: Cesium.Color.YELLOW.withAlpha(0.5),
          },
          position: new Cesium.CallbackProperty(() => {
            return newcoordinatesData[0]
          }, false) as any,
          label: {
            text:
              `높이:${Math.abs(Number(Number(this._getHeading(newcoordinatesData[0], newcoordinatesData[2])).toFixed(2)))} m\n`
              + `사선 거리 :${Number(this.getPositionDistanceHeight(this.transformCartesianArrayToWGS84Array([newcoordinatesData[0], newcoordinatesData[1]]))).toFixed(2)} m\n`
              + `수평 거리:${Number(this.getPositionDistanceHeight(this.transformCartesianArrayToWGS84Array([newcoordinatesData[1], newcoordinatesData[2]]))).toFixed(2)} m`,
            show: true,
            showBackground: true,
            font: '14px monospace',
            horizontalOrigin: Cesium.HorizontalOrigin.LEFT,
            verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
            pixelOffset: new Cesium.Cartesian2(50, -100), // left top
          },
          billboard: {
            image: './measure/close.png',
            show: true, // default
            pixelOffset: new Cesium.Cartesian2(35, -95), // default: (0, 0)
            eyeOffset: new Cesium.Cartesian3(0.0, 0.0, 0.0), // default
            horizontalOrigin: Cesium.HorizontalOrigin.CENTER, // default
            verticalOrigin: Cesium.VerticalOrigin.BOTTOM, // default: CENTER
            alignedAxis: Cesium.Cartesian3.ZERO, // default
            width: 30, // default: undefined
            height: 30, // default: undefined
          },
        })
        this?.dataSourceDraw?.entities.add(_trianglesEntity)
      }
    }
    // })
  }

  async watchEdit(index1: any) {
    if (this.TypeArr[index1] === 1) {
      const lnglatArr = word2Lnglat(this.cesiumview, this.coordinatesData[index1])
      const positionArr: any = []
      let lngindex = 0
      this?.dataSourceDraw?.entities.values.forEach((item: any, index: number) => {
        if (item.id && item.id.includes(`label1_${index1}`)) {
          const lastindex = Number(item.id.split('_')[2])
          positionArr.push(lnglatArr[lngindex])
          lngindex++
          if (lastindex !== 0) {
            const line = turf.lineString(positionArr)
            const lengthResult = turf.length(line, { units: 'kilometers' })
            item.label.text._value = `${(lengthResult * 1000).toFixed(2)}m`
          }
        }
        if (item.id && item.id.includes(`labelandclose1_${index1}`)) {
          //
          const lastindex = Number(item.id.split('_')[2])
          positionArr.push(lnglatArr[lngindex])
          lngindex++
          if (lastindex !== 0) {
            const line = turf.lineString(positionArr)
            const lengthResult = turf.length(line, { units: 'kilometers' })
            item.label.text._value = `${(lengthResult * 1000).toFixed(2)}m`
          }
        }
      })
    }
    else if (this.TypeArr[index1] === 2) {
      const positionArr = []
      let lngindex = 0
      const entities = this?.dataSourceDraw?.entities.values
      for (let index = 0; index < entities.length; index++) {
        if (entities[index].id && entities[index].id.includes(`label2_${index1}`)) {
          const lastindex = Number(entities[index].id.split('_')[2])
          positionArr.push(this.coordinatesData[index1][lngindex])
          lngindex++
          if (lastindex !== 0) {
            const res = await getPositionDistance(positionArr, this.cesiumview)
            entities[index].label.text._value = `${res}m`
          }
        }
        if (entities[index].id && entities[index].id.includes(`labelandclose2_${index1}`)) {
          //
          const lastindex = Number(entities[index].id.split('_')[2])
          positionArr.push(this.coordinatesData[index1][lngindex])
          lngindex++
          if (lastindex !== 0) {
            const res = await getPositionDistance(positionArr, this.cesiumview)
            entities[index].label.text._value = `${res}m`
          }
        }
      }
    }
    else if (this.TypeArr[index1] === 3) {
      const positionArr = []
      const lngindex = 0

      this?.dataSourceDraw?.entities.values.forEach((item: any, index: number) => {
        if (item.id && item.id.includes(`labelandclose3_${index1}`)) {
          const newcoordinatesData = [...this.coordinatesData[index1]]
          newcoordinatesData.push(newcoordinatesData[0])
          const lnglatArr = word2Lnglat(this.cesiumview, newcoordinatesData)
          const polygon = turf.polygon([lnglatArr])
          const area = turf.area(polygon)
          item.label.text._value = `${area.toFixed(2)}m`
        }
      })
    }
    else if (this.TypeArr[index1] === 4) {
      const positionArr = []
      const lngindex = 0

      this?.dataSourceDraw?.entities.values.forEach((item: any, index: number) => {
        if (item.id && item.id.includes(`labelandclose4_${index1}`)) {
          this?.dataSourceDraw?.entities.remove(item)
          const newcoordinatesData = [...this.coordinatesData[index1]]
          newcoordinatesData.push(this._computesHorizontalLine(this.coordinatesData[index1]))
          newcoordinatesData.push(this.coordinatesData[index1][0])

          const _trianglesEntity = new Cesium.Entity({
            id: `labelandclose4_${index1}_${0}`,
            name: `measure4_${index1}`,
            polyline: {
              positions: newcoordinatesData,
              width: 3,
              material: Cesium.Color.YELLOW.withAlpha(0.5),
            },
            position: new Cesium.CallbackProperty(() => {
              return newcoordinatesData[0]
            }, false) as any,
            label: {
              text:
                `높이:${Math.abs(Number(Number(this._getHeading(newcoordinatesData[0], newcoordinatesData[2])).toFixed(2)))} m\n`
                + `사선 거리 :${Number(this.getPositionDistanceHeight(this.transformCartesianArrayToWGS84Array([newcoordinatesData[0], newcoordinatesData[1]]))).toFixed(2)} m\n`
                + `수평 거리:${Number(this.getPositionDistanceHeight(this.transformCartesianArrayToWGS84Array([newcoordinatesData[1], newcoordinatesData[2]]))).toFixed(2)} m`,
              show: true,
              showBackground: true,
              font: '16px monospace',
              horizontalOrigin: Cesium.HorizontalOrigin.LEFT,
              verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
              pixelOffset: new Cesium.Cartesian2(50, -100), // left top
            },
            billboard: {
              image: './measure/close.png',
              show: true, // default
              pixelOffset: new Cesium.Cartesian2(35, -95), // default: (0, 0)
              eyeOffset: new Cesium.Cartesian3(0.0, 0.0, 0.0), // default
              horizontalOrigin: Cesium.HorizontalOrigin.CENTER, // default
              verticalOrigin: Cesium.VerticalOrigin.BOTTOM, // default: CENTER
              alignedAxis: Cesium.Cartesian3.ZERO, // default
              width: 30, // default: undefined
              height: 30, // default: undefined
            },
          })
          this?.dataSourceDraw?.entities.add(_trianglesEntity)
        }
      })
    }
  }

  closeSimpleEntity(closedCallback: () => void) {
    if (this.pickHandler) {
      //
    }
    else {
      this.pickHandler = new Cesium.ScreenSpaceEventHandler(this.cesiumview.scene.canvas)
    }
    this.pickHandler.setInputAction((movement: any) => {
      const pick = this.cesiumview.scene.pick(movement.position)
      const entities = this?.dataSourceDraw?.entities.values

      if (pick && pick.primitive && pick.primitive instanceof Cesium.Billboard && pick.id.id.includes('labelandclose')) {
        const name = pick.id._name
        let indexi = 0
        for (let i = 0; i < entities.length; i++) {
          if (entities[i].name && entities[i].name === name) {
            const index1 = Number(name.split('_')[1])
            if (indexi === 0) {
              this.coordinatesData.splice(index1, 1)
              this.TypeArr.splice(index1, 1)
            }
            indexi++
            this?.dataSourceDraw?.entities.remove(entities[i])
            this.cesiumview._container.style.cursor = 'default'
            closedCallback()
            i--
          }
        }
        this.againDrawGraphical()
      }
    }, Cesium.ScreenSpaceEventType.LEFT_CLICK)

    this.pickHandler.setInputAction((movement: any) => {
      const pick = this.cesiumview.scene.pick(movement.endPosition)
      if (pick && pick.primitive && pick.primitive instanceof Cesium.Billboard && pick.id.billboard) {
        pick.id.billboard.image.setValue('./measure/closefill.png')
        this.pickBillboard = pick.id.billboard.image
        this.cesiumview._container.style.cursor = 'pointer'
      }
      else {
        if (this.pickBillboard) {
          this.pickBillboard.setValue('./measure/close.png')
          this.pickBillboard = null
          this.cesiumview._container.style.cursor = 'default'
        }
      }
    }, Cesium.ScreenSpaceEventType.MOUSE_MOVE)
  }

  destroy() {
    if (this.drawTool) {
      this.drawTool.destroy && this.drawTool.destroy()
      this.drawTool.reset && this.drawTool.reset()
      this.drawTool.clear && this.drawTool.clear()

      this.drawTool = null
    }
    if (this?.dataSourceDraw) {
      this?.dataSourceDraw?.entities.removeAll()
      this.dataSourceDraw = null
    }

    this.coordinatesData = [] // save draw coordinates data
    this.TypeArr = []
    if (this?.pickHandler) {
      this.pickHandler?.destroy()
      this.pickHandler = null //
    }
    if (this.pickBillboard) {
      this.pickBillboard.destroy && this.pickBillboard.destroy()
      this.pickBillboard = null
    }
    if (this?._handlersHeight) {
      this._handlersHeight?.destroy()
      this._handlersHeight = null
    }

    this._isStartMeasure = false
  }

  _getHeading(startPosition: any, endPosition: any) {
    if (!startPosition && !endPosition)
      return 0
    if (Cesium.Cartesian3.equals(startPosition, endPosition))
      return 0
    const cartographic = Cesium.Cartographic.fromCartesian(startPosition)
    const cartographic2 = Cesium.Cartographic.fromCartesian(endPosition)
    return (cartographic2.height - cartographic.height).toFixed(2)
  }

  // pian yi point
  _computesHorizontalLine(positions: any) {
    const cartographic = Cesium.Cartographic.fromCartesian(positions[0])
    const cartographic2 = Cesium.Cartographic.fromCartesian(positions[1])
    return Cesium.Cartesian3.fromDegrees(Cesium.Math.toDegrees(cartographic.longitude), Cesium.Math.toDegrees(cartographic.latitude), cartographic2.height)
  }

  getPositionDistanceHeight(positions: any) {
    let distance = 0
    for (let i = 0; i < positions.length - 1; i++) {
      const point1cartographic = this.transformWGS84ToCartographic(positions[i])
      const point2cartographic = this.transformWGS84ToCartographic(positions[i + 1])
      const geodesic = new Cesium.EllipsoidGeodesic()
      geodesic.setEndPoints(point1cartographic, point2cartographic)
      let s = geodesic.surfaceDistance
      s = Math.sqrt(s ** 2 + (point2cartographic.height - point1cartographic.height) ** 2)
      distance = distance + s
    }
    return distance.toFixed(3)
  }

  transformCartesianArrayToWGS84Array(cartesianArr: any) {
    if (this.cesiumview) {
      return cartesianArr
        ? cartesianArr.map((item: any) => {
          return this.transformCartesianToWGS84(item)
        })
        : []
    }
  }

  transformWGS84ToCartographic(position: any) {
    return position ? Cesium.Cartographic.fromDegrees(position.lng || position.lon, position.lat, position.alt) : Cesium.Cartographic.ZERO
  }

  getCatesian3FromPX(px: any) {
    if (this.cesiumview && px) {
      const picks = this.cesiumview.scene.drillPick(px)
      let cartesian = null
      let isOn3dtiles = false
      let isOnTerrain = false
      // drillPick
      for (const i in picks) {
        const pick = picks[i]

        if ((pick && pick.primitive instanceof Cesium.Cesium3DTileFeature) || (pick && pick.primitive instanceof Cesium.Cesium3DTileset) || (pick && pick.primitive instanceof Cesium.Model)) {
          // Pick on model
          isOn3dtiles = true
        }
        // 3dtilset
        if (isOn3dtiles) {
          this.cesiumview.scene.pick(px) // pick
          cartesian = this.cesiumview.scene.pickPosition(px)
          if (cartesian) {
            const cartographic = Cesium.Cartographic.fromCartesian(cartesian)
            if (cartographic.height < 0)
              cartographic.height = 0
            const lon = Cesium.Math.toDegrees(cartographic.longitude)
            const lat = Cesium.Math.toDegrees(cartographic.latitude)
            const height = cartographic.height
            cartesian = this.transformWGS84ToCartesian({
              lng: lon,
              lat,
              alt: height,
            })
          }
        }
      }
      // terrain
      const boolTerrain = this.cesiumview.terrainProvider instanceof Cesium.EllipsoidTerrainProvider
      // Terrain
      if (!isOn3dtiles && !boolTerrain) {
        const ray = this.cesiumview.scene.camera.getPickRay(px)
        if (!ray)
          return null
        cartesian = this.cesiumview.scene.globe.pick(ray, this.cesiumview.scene)
        isOnTerrain = true
      }
      // global
      if (!isOn3dtiles && !isOnTerrain && boolTerrain) {
        cartesian = this.cesiumview.scene.camera.pickEllipsoid(px, this.cesiumview.scene.globe.ellipsoid)
      }
      if (cartesian) {
        const position: any = this.transformCartesianToWGS84(cartesian)
        if (position.alt < 0) {
          cartesian = this.transformWGS84ToCartesian(position, 0.1)
        }
        return cartesian
      }
      return false
    }
  }

  transformCartesianToWGS84(cartesian: any) {
    if (this.cesiumview && cartesian) {
      const ellipsoid = Cesium.Ellipsoid.WGS84
      const cartographic = ellipsoid.cartesianToCartographic(cartesian)
      return {
        lng: Cesium.Math.toDegrees(cartographic.longitude),
        lat: Cesium.Math.toDegrees(cartographic.latitude),
        alt: cartographic.height,
      }
    }
  }

  transformWGS84ToCartesian(position: any, alt?: any) {
    if (this.cesiumview) {
      return position ? Cesium.Cartesian3.fromDegrees(position.lng || position.lon, position.lat, (position.alt = alt || position.alt), Cesium.Ellipsoid.WGS84) : Cesium.Cartesian3.ZERO
    }
  }
}

export default CustomMeasureNew
